export default __webpack_public_path__ + "static/media/Db4.7782765c.mp3";